export default __webpack_public_path__ + "static/media/check-circle.1bedf6af.svg";